import { useTranslation } from "react-i18next";
import { useAuth } from "../contexts/AuthContext";
import { STORAGE_KEY } from "../i18n";
import { cn } from "../lib/utils";

const LANGS = [
  { code: "en", label: "EN", flag: "🇬🇧" },
  { code: "es", label: "ES", flag: "🇪🇸" },
  { code: "hi", label: "हिं", flag: "🇮🇳" },
  { code: "it", label: "IT", flag: "🇮🇹" },
  { code: "fr", label: "FR", flag: "🇫🇷" },
];

export function LanguageSwitcher({ className }) {
  const { i18n } = useTranslation();
  const { isAuthed, updateProfile } = useAuth();

  const change = async (code) => {
    await i18n.changeLanguage(code);
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (_) {
      // ignore storage failures (private mode etc.)
    }
    if (isAuthed) {
      // best-effort persist to profile; ignore errors
      updateProfile({ language: code });
    }
  };

  const current = i18n.resolvedLanguage || i18n.language || "en";

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-white/10",
        "bg-white/[0.04] backdrop-blur-md p-1",
        className,
      )}
      data-testid="language-switcher"
    >
      {LANGS.map((l) => {
        const active = current.startsWith(l.code);
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => change(l.code)}
            data-testid={`lang-btn-${l.code}`}
            className={cn(
              "px-2.5 py-1 text-xs font-medium rounded-full transition-colors duration-150 inline-flex items-center gap-1",
              active
                ? "bg-[#D4AF37] text-[#0a0a0d] shadow-[0_4px_14px_-4px_rgba(212,175,55,0.7)]"
                : "text-white/70 hover:text-white",
            )}
            aria-pressed={active}
            title={l.code.toUpperCase()}
          >
            <span aria-hidden className="text-[11px] leading-none">{l.flag}</span>
            <span>{l.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default LanguageSwitcher;
